import { render, staticRenderFns } from "./AdminOrderHistoryGrid.vue?vue&type=template&id=06605c74&"
import script from "./AdminOrderHistoryGrid.vue?vue&type=script&lang=js&"
export * from "./AdminOrderHistoryGrid.vue?vue&type=script&lang=js&"
import style0 from "./AdminOrderHistoryGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports